<script setup lang="ts">
import { ref } from "vue";
const route = useRoute();
const site = useSite();

const legalPages = computed(() =>
  (site.value?.children ?? []).filter((i: any) => i.template === "legal"),
);

const creditDue = ref(false);
</script>

<template>
  <footer class="footer">
    <div class="container">
      <AppNewsletter />
    </div>
    <AppFooterContact />
    <AppFooterLogos />
    <div class="container2">
      <div class="footer-graphic">
        <AppSVGBrandGraphic />
      </div>
      <div class="footer-pages">
        <ul id="footerNav">
          <li
            v-for="item in legalPages"
            :key="item.id"
            :class="`item-${item.id}`"
            class="menu-item"
          >
            <NuxtLink
              :to="{ path: `/${item.id}` }"
              :aria-current="
                route.path.startsWith(`/${item.id}`) ? 'page' : undefined
              "
            >
              {{ item.title }}
            </NuxtLink>
          </li>
        </ul>
        <div class="copyright">
          <p>&copy; {{ new Date().getFullYear() }} / Mont Blanc Treks Ltd.</p>
        </div>
        <div v-if="creditDue">
          <AppSVGCreditDue />
        </div>
      </div>
      <div class="footer-logo">
        <AppFooterLogo />
      </div>
    </div>
  </footer>
</template>
